import { ResultCardSkeleton } from './index';
import './SearchLoader.css';

const SearchLoader = () => {
    return (
        <div className="search-loader-container">
            {[1, 2, 3].map((item) => (
                <ResultCardSkeleton key={item} />
            ))}
        </div>
    );
};

export default SearchLoader;
